<div class="tabbable">
    <div class="tab-content">
        <ng-content></ng-content>
    </div>
</div>